import { render, staticRenderFns } from "./HistoryDatasetIndex.vue?vue&type=template&id=60030846"
import script from "./HistoryDatasetIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryDatasetIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports